<template>
  <div>
    <Loading :visible="isLoadingPop"></Loading>
    <paymentPop :month="toMonths" :visible="isPaymentPop" @close="popClose"></paymentPop>
    <div class="wrap payment-wrap">
      <div class="top-header">
        <!-- <button><img src="@/assets/img/back-icon.svg" alt="preview"></button> -->
        <h3>Payment</h3>
      </div>
      <div class="body-wrap">
        <select v-model="toMonths" @change="getPayment()">
          <option v-for="(item, index) in months" :key="index" :value="item.value">{{ item.text }}</option>
        </select>
        <div class="payment-view">
          <h1>{{ this.$store.state.userInfo.userName }}님 {{ month }}월분 급여 명세서</h1>

          <table class="info-table">
            <tr>
              <th>이름</th>
              <td colspan="3">{{ this.$store.state.userInfo.userName }}({{ this.$store.state.userInfo.userEmail }})</td>
            </tr>
            <tr>
              <th>연락처</th>
              <td>{{ this.$store.state.userInfo.userHandphone }}</td>
              <th>지급일</th>
              <td>{{ payment.paymentInsertdate }}</td>
            </tr>
          </table>
          <table class="payment-table">
            <tr>
              <td class="w-70per pl-20">코칭료</td>
              <td class="txt-center">
                <span @click="showPaymentPop()">{{ payment.paymentCoarchingPrice | comma }}</span>
              </td>
            </tr>
            <tr>
              <td class="w-70per pl-20">교통비</td>
              <td class="txt-center">{{ payment.paymentTrafficPrice | comma }}</td>
            </tr>
            <tr>
              <td class="w-70per pl-20">특별수당</td>
              <td class="txt-center">{{ payment.paymentSpecialPrice | comma }}</td>
            </tr>
            <tr>
              <td class="w-70per pl-20">기타</td>
              <td class="txt-center">{{ payment.paymentEtcPrice | comma }}</td>
            </tr>
            <tr class="bold">
              <td class="w-70per pl-20 pb-20">소득합계</td>
              <td class="txt-center">
                {{
                  (Number(payment.paymentCoarchingPrice) +
                    Number(payment.paymentTrafficPrice) +
                    Number(payment.paymentSpecialPrice) +
                    Number(payment.paymentEtcPrice))
                    | comma
                }}
              </td>
            </tr>
          </table>
          <table class="payment-table">
            <tr>
              <td class="w-70per pl-20">소득세</td>
              <td class="txt-center">{{ payment.paymentIncomingTax | comma }}</td>
            </tr>
            <tr>
              <td class="w-70per pl-20">주민세</td>
              <td class="txt-center">{{ payment.paymentResidentTax | comma }}</td>
            </tr>
            <tr class="bold">
              <td class="w-70per pl-20 pb-20">공제합계</td>
              <td class="txt-center">{{ payment.paymentTotalTax | comma }}</td>
            </tr>
            <tr class="bold bg">
              <td class="w-70per pl-20">지급 총액</td>
              <td class="txt-center">{{ payment.paymentPrice | comma }}</td>
            </tr>
          </table>
        </div>
        <p>*급여는 이전달 1일~말일까지 진행한 코칭 건에 대해 지급됩니다.</p>
      </div>
      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incTab from "@/components/inc/inc_tab.vue";
import { pad } from "@/utils/common.js";
import dayjs from "dayjs";
import paymentPop from "@/components/pop/payment_pop.vue";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "payment_view",
  data: () => ({
    isPop: false,
    months: [],
    month: "",
    toMonths: "",
    payment: {},
    paymentIdx: 0,
    isPaymentPop: false,
    isLoadingPop: true,
  }),
  components: {
    incTab,
    paymentPop,
    Loading,
  },
  mounted() {
    let date = new Date();
    let year = date.getFullYear();
    for (let i = 1; i <= 12; i++) {
      this.months.push({ value: year + "-" + pad(i), text: year + "년 " + i + "월" });
    }
    this.toMonths = dayjs().format("YYYY-MM");

    this.month = this.toMonths.split("-")[1];

    this.getPayment();
  },
  methods: {
    popClose() {
      this.isPaymentPop = false;
    },
    getPayment() {
      this.isLoadingPop = true;
      let params = {
        month: this.toMonths,
      };
      this.month = this.toMonths.split("-")[1];
      this.axios
        .get("/front/coarch/paymentByMonth?", { params })
        .then((res) => {
          if (res.data.success) {
            if (res.data.contentinfo == null) {
              this.payment = {
                paymentCoarchingPrice: 0,
                paymentTrafficPrice: 0,
                paymentSpecialPrice: 0,
                paymentEtcPrice: 0,
                paymentIncomingTax: 0,
                paymentTotalTax: 0,
                paymentResidentTax: 0,
                paymentPrice: 0,
              };
            } else {
              this.payment = res.data.contentinfo;
              this.payment.paymentPrice =
                Number(this.payment.paymentCoarchingPrice) +
                Number(this.payment.paymentTrafficPrice) +
                Number(this.payment.paymentSpecialPrice) +
                Number(this.payment.paymentEtcPrice) -
                Number(this.payment.paymentTotalTax);
            }
            this.payment.paymentInsertdate = dayjs(this.payment.paymentInsertdate).format("YYYY년 MM월 DD일");
            this.isLoadingPop = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showPaymentPop() {
      this.paymentIdx = this.payment.paymentIdx;
      this.isPaymentPop = true;
    },
    showDetail() {
      this.isPop = true;
    },
    close() {
      this.isPop = false;
    },
  },
};
</script>
